export default {
  // Common
  'pages.common.more': 'More',

  // Speakers
  'pages.console.speakers.column.speaker': 'Speaker',
  'pages.console.speakers.column.samples': 'Samples',
  'pages.console.speakers.error.sampleTooShort': 'Sample too short, at least 2 seconds required',
  'pages.console.speakers.error.recordFirst': 'Please record first, or the recording is invalid',
  'pages.console.speakers.error.selectConversation': 'Please select a conversation audio',
  'pages.console.speakers.msg.convUploadSuccess': 'Conversation audio uploaded successfully',
  'pages.console.speakers.msg.convUploadFailed': 'Failed to upload conversation audio',
  'pages.console.speakers.msg.saveSuccess': 'Saved successfully',
  'pages.console.speakers.msg.saveFailed': 'Save failed',
  'pages.console.speakers.modal.edit': 'Edit',
  'pages.console.speakers.uploadFile': 'Upload file',
  'pages.console.speakers.conversation': 'Conversation audio',
  'pages.console.speakers.stopRecording': 'Click to stop recording',
  'pages.console.speakers.startRecording': 'Click to start recording',

  // MemoryObservationCandidates
  'pages.memoryObservation.status.pending': 'Pending',
  'pages.memoryObservation.status.promoted': 'Promoted',
  'pages.memoryObservation.status.rejected': 'Rejected',
  'pages.memoryObservation.status.decayed': 'Decayed',
  'pages.memoryObservation.slot.age': 'Age',
  'pages.memoryObservation.slot.communicationStyle': 'Communication style',
  'pages.memoryObservation.slot.dislikes': 'Dislikes',
  'pages.memoryObservation.slot.family': 'Family',
  'pages.memoryObservation.slot.relationships': 'Relationships',
  'pages.memoryObservation.slot.extra': 'Other',
  'pages.memoryObservation.msg.loadFailed': 'Failed to load observation pool',
  'pages.memoryObservation.msg.promoteSuccess': 'Merged into long-term profile',
  'pages.memoryObservation.msg.promoteFailed': 'Promotion failed',
  'pages.memoryObservation.msg.rejectSuccess': 'Marked as rejected',
  'pages.memoryObservation.msg.rejectFailed': 'Operation failed',
  'pages.memoryObservation.loading': 'Loading observation pool…',
  'pages.memoryObservation.disabled.title': 'Observation pool not enabled',
  'pages.memoryObservation.disabled.desc':
    'After enabling "Long-term memory observation pool" in the admin console (System Config → Application), cross-session candidate facts will be listed here. They can be auto-promoted once the hit threshold is reached, or manually confirmed or rejected.',
  'pages.memoryObservation.hint.autoPromotePrefix': 'Auto-promotion requires the same slot to be hit across ',
  'pages.memoryObservation.hint.autoPromoteMid': ' distinct conversations; memoryCollectionDays (compatibility config): ',
  'pages.memoryObservation.column.slot': 'Slot',
  'pages.memoryObservation.column.content': 'Content',
  'pages.memoryObservation.column.convCount': 'Conversations',
  'pages.memoryObservation.tag.promotable': 'Promotable',
  'pages.memoryObservation.column.confidence': 'Confidence',
  'pages.memoryObservation.column.source': 'Source',
  'pages.memoryObservation.tag.fastLane': 'Fast lane',
  'pages.memoryObservation.tag.collected': 'Collected',
  'pages.memoryObservation.column.device': 'Device',
  'pages.memoryObservation.column.convId': 'Conversation ID',
  'pages.memoryObservation.column.createdAt': 'Created at',
  'pages.memoryObservation.column.lastSeen': 'Last hit',
  'pages.memoryObservation.tooltip.lastSeen': 'The most recent time the candidate was reinforced/hit in a conversation',
  'pages.memoryObservation.column.status': 'Status',
  'pages.memoryObservation.column.action': 'Actions',
  'pages.memoryObservation.button.promote': 'Confirm write',
  'pages.memoryObservation.button.reject': 'Reject',

  // LongTermMemoryAnchors
  'pages.memoryAnchors.msg.getStatusFailed': 'Failed to get long-term memory status',
  'pages.memoryAnchors.msg.getChunksFailed': 'Failed to get long-term memory anchors',
  'pages.memoryAnchors.msg.searchFailed': 'Failed to search long-term memory',
  'pages.memoryAnchors.msg.contentRequired': 'Memory content cannot be empty',
  'pages.memoryAnchors.msg.updateSuccess': 'Memory anchor updated',
  'pages.memoryAnchors.msg.updateFailed': 'Failed to update memory anchor',
  'pages.memoryAnchors.msg.deleteSuccess': 'Memory anchor deleted',
  'pages.memoryAnchors.msg.deleteFailed': 'Failed to delete memory anchor',
  'pages.memoryAnchors.clear.confirmTitle': 'Clear all vector long-term memory?',
  'pages.memoryAnchors.clear.confirmContent':
    'This will delete all summary anchors in the current agent memory base. Disabling long-term memory will not trigger this. This cannot be undone.',
  'pages.memoryAnchors.clear.confirmOk': 'Confirm clear',
  'pages.memoryAnchors.clear.success': 'Cleared {count} memory anchors',
  'pages.memoryAnchors.clear.refreshFailed': 'Cleared successfully, but refreshing the list failed. Please click "Refresh anchors" to retry',
  'pages.memoryAnchors.clear.failed': 'Failed to clear long-term memory',
  'pages.memoryAnchors.needSave': 'You can manage long-term memory anchors only after saving the agent.',
  'pages.memoryAnchors.column.content': 'Content',
  'pages.memoryAnchors.column.action': 'Actions',
  'pages.memoryAnchors.button.save': 'Save',
  'pages.memoryAnchors.button.edit': 'Edit',
  'pages.memoryAnchors.button.delete': 'Delete',
  'pages.memoryAnchors.button.refresh': 'Refresh anchors',
  'pages.memoryAnchors.button.clearAll': 'Clear all vector memory',
  'pages.memoryAnchors.delete.confirmTitle': 'Delete this memory anchor?',
  'pages.memoryAnchors.delete.confirmOk': 'Delete',
  'pages.memoryAnchors.alert.title': 'Vector long-term memory base',
  'pages.memoryAnchors.alert.desc':
    'This manages summary anchors written to the vector store automatically after conversations; the JSON above is structured profile memory. The two are independent.',
  'pages.memoryAnchors.tag.enabled': 'Enabled',
  'pages.memoryAnchors.tag.disabled': 'Disabled',
  'pages.memoryAnchors.tag.notCreated': 'Not created',
  'pages.memoryAnchors.tag.systemOff': 'System switch off',
  'pages.memoryAnchors.search.placeholder': 'Enter a question or keyword to preview long-term memory retrieval results',
  'pages.memoryAnchors.searchPreview': 'Retrieval preview',
  'pages.memoryAnchors.search.similarity': 'Similarity {score}',

  // AgentMemorySetting
  'pages.agentMemorySetting.observationPool.label': 'Observation pool candidates',
  'pages.agentMemorySetting.observationPool.tooltip':
    'Requires enabling "Long-term memory observation pool" in the admin console. Reaching the cross-session hit count auto-writes into the profile; you can also confirm or reject manually here.',
  'pages.agentMemorySetting.vectorAnchor.label': 'Vector anchors',

  // AgentSetting long-term profile placeholders
  'pages.agentSetting.memory.longTerm.placeholder.birthday': 'e.g. March 15, 1990-05-20',
  'pages.agentSetting.memory.longTerm.placeholder.mbti': 'e.g. INTJ',
  'pages.agentSetting.memory.longTerm.placeholder.timezone': 'e.g. UTC+8',
  'pages.agentSetting.memory.longTerm.placeholder.communication_style': 'e.g. concise, humorous',

  // AgentSetting provider commercial license
  'pages.agentSetting.provider.commercialLicenseRequired': '{name} (commercial license required)',

  // Agents commercial tag
  'pages.agents.tag.commercial': 'Commercial',

  // Settings OpenID
  'pages.settings.openid.label': 'OpenID: ',

  // Devices SIM card state enums + copy tooltips
  'pages.devices.simState.hintWrap': '{raw} ({hint})',
  'pages.devices.simState.sp.1': 'China Mobile',
  'pages.devices.simState.sp.2': 'China Unicom',
  'pages.devices.simState.sp.3': 'China Telecom',
  'pages.devices.simState.cardForm.1': 'Plug-in',
  'pages.devices.simState.cardForm.2': 'Ceramic',
  'pages.devices.simState.cardForm.3': 'SMT',
  'pages.devices.simState.cardForm.4': 'MP2',
  'pages.devices.simState.cardCl.1': 'Testing',
  'pages.devices.simState.cardCl.2': 'Silent',
  'pages.devices.simState.cardCl.3': 'In service',
  'pages.devices.simState.cState.1': 'Suspended',
  'pages.devices.simState.cState.2': 'Normal',
  'pages.devices.simState.cState.3': 'Pending activation',
  'pages.devices.simState.cState.4': 'Pre-closed',
  'pages.devices.simState.cState.5': 'Closed',
  'pages.devices.simState.cState.6': 'Dormant',
  'pages.devices.simState.cState.7': 'Closure requested',
  'pages.devices.simState.gprsState.1': 'Normal',
  'pages.devices.simState.gprsState.2': 'Barred, resume next month',
  'pages.devices.simState.gprsState.3': 'Barred, no resume next month',
  'pages.devices.simState.gprsState.4': 'User barred, no auto resume',
  'pages.devices.copy.macTooltip': 'Copy full MAC',
  'pages.devices.copy.macCopiedTooltip': 'MAC copied',
  'pages.devices.copy.iccidTooltip': 'Copy ICCID',
  'pages.devices.copy.iccidCopiedTooltip': 'ICCID copied',
};
